export default __webpack_public_path__ + "alberta-more.e041fd9e07b4eb5c4789.svg";